/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/FactBox/theme';

export const FactBoxTheme = theme;
